import { useTranslation } from 'react-i18next'
import LogoBtvDarkDe from '../../assets/btv-dark-de.png'
import LogoBtvLightDe from '../../assets/btv-light-de.png'
import LogoBtvDarkNl from '../../assets/btv-dark-nl.png'
import LogoBtvLightNl from '../../assets/btv-light-nl.png'
import LogoNetco from '../../assets/netco.png'

// Locale-aware logos + external links (imprint / privacy / btv / netco). Falls back to `de` for unknown locales.
export const useMedia = () => {
    const { i18n } = useTranslation()

    const locale = i18n.language.slice(0, 2).toLowerCase()

    const logos = {
        btv: {
            de: { dark: LogoBtvDarkDe, light: LogoBtvLightDe },
            nl: { dark: LogoBtvDarkNl, light: LogoBtvLightNl },
        },
        netco: {
            de: LogoNetco
        }
    }

    const links = {
        imprint: {
            de: 'https://www.netco.de/impressum/',
            nl: 'https://bouwtvplus.nl/colofon/',
        },
        privacy: {
            de: 'https://www.netco.de/datenschutz/',
            nl: 'https://bouwtvplus.nl/privacybeleid/',
        },
        btv: {
            de: 'https://www.netco.de/baustellen-webcam/',
            nl: 'https://bouwtvplus.nl/',
        },
        netco: {
            de: 'https://www.netco.de/',
            nl: 'https://www.netco.de/',
        }
    }

    return {
        logos: Object.fromEntries(Object.entries(logos).map(([key, values]) => [key, values[locale] || values.de])),
        links: Object.fromEntries(Object.entries(links).map(([key, values]) => [key, values[locale] || values.de]))
    }
}
